import { FAIcon } from '~/components/utils/FAIcons';

export default function MapBoxErrorFallback() {
	return (
		<div className="flex gap-1 w-full h-full items-center justify-center text-orange-700">
			<FAIcon icon="exclamation-triangle" />
			There was a problem loading the map
		</div>
	);
}
